// Imports
import React from 'react';
import Notice from '../../../../notice';
import { PaymentMethodType } from '../utils/determine-payment-method-type-statuses';


// Define the accepted props
interface Props {
	page: 'MAKE_PAYMENT' | 'STORED_PAYMENT_METHODS';
	type: PaymentMethodType;
	pendingVerification: boolean;
}


// Map each page and payment method type to what members can't do
const unavailablePaymentMethodTypePhrases: Record<Props['page'], Record<PaymentMethodType, string>> = {
	MAKE_PAYMENT: {
		CARD: 'Cards cannot be used to make a payment',
		BANK_ACCOUNT: 'Bank accounts cannot be used to make a payment',
	},
	STORED_PAYMENT_METHODS: {
		CARD: 'Cards cannot be added',
		BANK_ACCOUNT: 'Bank accounts cannot be added',
	},
};


// Function component
const UnavailablePaymentMethodTypeNotice: React.FC<Props> = ({ page, type, pendingVerification }) => (
	<Notice color='yellow'>
		<strong>Heads up.</strong> {unavailablePaymentMethodTypePhrases[page][type]} until{' '}
		{pendingVerification
			? 'our payment processing partner finishes reviewing your community’s information'
			: 'a website admin provides requested information'}
		.
	</Notice>
);

export default UnavailablePaymentMethodTypeNotice;
